import {AdAnalyticsSample} from '../types/AdAnalyticsSample';
import {AdBreakSample} from '../types/AdBreakSample';
import {AdSample} from '../types/AdSample';
import {Sample} from '../types/Sample';

import {Backend} from './Backend';

/**
 * The `QueueBackend` class is responsible for queuing samples for deferred processing.
 * Samples are stored in different queues depending on the sample type and can be flushed
 * to another backend for further processing.
 *
 * This is useful e.g. to still collect sample data while waiting for a license call to succeed.
 *
 * @implements {Backend}
 */
export class QueueBackend implements Backend {
  queue: Sample[] = [];
  unloadQueue: Sample[] = [];
  syncQueue: Sample[] = [];
  adQueue: Array<AdAnalyticsSample & AdBreakSample & AdSample> = [];

  sendRequest(sample: Sample) {
    this.queue.push(sample);
  }
  sendUnloadRequest(sample: Sample) {
    this.unloadQueue.push(sample);
  }
  sendRequestSynchronous(sample: Sample) {
    this.syncQueue.push(sample);
  }
  sendAdRequest(sample: AdAnalyticsSample & AdBreakSample & AdSample) {
    this.adQueue.push(sample);
  }

  flushTo(backend: Backend) {
    this.queue.forEach((e) => {
      backend.sendRequest(e);
    });
    this.unloadQueue.forEach((e) => {
      backend.sendUnloadRequest(e);
    });
    this.syncQueue.forEach((e) => {
      backend.sendRequestSynchronous(e);
    });
    this.adQueue.forEach((e) => {
      backend.sendAdRequest(e);
    });
  }
}
